import { render } from "./DownloadsSection.vue?vue&type=template&id=7d873592&scoped=true"
import script from "./DownloadsSection.vue?vue&type=script&lang=js"
export * from "./DownloadsSection.vue?vue&type=script&lang=js"

import "./DownloadsSection.vue?vue&type=style&index=0&id=7d873592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d873592"]])

export default __exports__